export default __webpack_public_path__ + "static/media/download.5825c683.svg";